'use client';

import { useRouter , usePathname } from 'next/navigation';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

export default function CTASection({ ctaTitle, ctaText }) {
  const router = useRouter();
  const pathname = usePathname();
  const isHomePage = pathname === '/';
  return (
    <section className="hero">
      <div className="background">
        <div className="leftGlow" />
        <div className="rightGlow" />
        <div className="centerGlow" />
        <div className="fadeBottom" />
        <div className="grid" />

        {/* Decorative Lines */}
        <span className="line line1" />
        <span className="line line2" />
        <span className="line line3" />
        <span className="line line4" />
      </div>

      <div className="content">
        <span className="badge"> Let's Work Together</span>

        <h1>
          {isHomePage && <>Ready to Transform </>}
          <span>{ctaTitle}</span>
        </h1>

        <p>
        {ctaText}
        </p>

        <div className="buttons">
          <button  onClick={() => router.push('/book')} className="primary">
            Book A Call →
          </button>

          
        </div>
      </div>

      <style jsx>{`
        .hero {
          position: relative;
          overflow: hidden;
          min-height: 90vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: white;
        }

        .background {
          position: absolute;
          inset: 0;
          overflow: hidden;
        }

        /* LEFT GLOW */
        .leftGlow {
          position: absolute;
          width: 90vw;
          height: 70vw;
          left: -40vw;
          top: -42vw;
          background: radial-gradient(
            ellipse at center,
            rgba(249, 115, 22, 0.45) 0%,
            rgba(251, 146, 60, 0.28) 35%,
            rgba(253, 186, 116, 0.14) 55%,
            transparent 78%
          );
          filter: blur(18px);
        }

        /* RIGHT GLOW */
        .rightGlow {
          position: absolute;
          width: 90vw;
          height: 70vw;
          right: -40vw;
          top: -42vw;
          background: radial-gradient(
            ellipse at center,
            rgba(249, 115, 22, 0.45) 0%,
            rgba(251, 146, 60, 0.28) 35%,
            rgba(253, 186, 116, 0.14) 55%,
            transparent 78%
          );
          filter: blur(18px);
        }

        /* Middle Glow */
        .centerGlow {
          position: absolute;
          left: 50%;
          top: 8%;
          transform: translateX(-50%);
          width: 55vw;
          height: 35vw;
          background: radial-gradient(
            ellipse,
            rgba(251, 146, 60, 0.12),
            transparent 70%
          );
          filter: blur(35px);
        }

        /* Fade */
        .fadeBottom {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to bottom,
            rgba(255,255,255,0) 0%,
            rgba(255,255,255,0.08) 40%,
            rgba(255,255,255,0.65) 72%,
            white 100%
          );
        }

        /* Grid */
        .grid {
          position: absolute;
          inset: 0;
          opacity: .03;
          background-image:
            linear-gradient(to right,#f97316 1px,transparent 1px),
            linear-gradient(to bottom,#f97316 1px,transparent 1px);
          background-size: 72px 72px;
        }

        .line{
          position:absolute;
          width:1px;
          background:linear-gradient(
            to bottom,
            transparent,
            rgba(249,115,22,.35),
            transparent
          );
        }

        .line1{
          left:18%;
          top:0;
          height:260px;
        }

        .line2{
          left:35%;
          top:40px;
          height:180px;
        }

        .line3{
          right:20%;
          top:0;
          height:260px;
        }

        .line4{
          right:35%;
          top:50px;
          height:170px;
        }

        .content{
          position:relative;
          z-index:10;
          max-width:850px;
          padding:40px;
          text-align:center;
        }

        .badge{
          display:inline-block;
          padding:10px 18px;
          border-radius:999px;
          background:#fff7ed;
          border:1px solid #fdba74;
          color:#ea580c;
          font-weight:600;
        }

        h1{
          margin-top:30px;
          font-size:72px;
          line-height:1.05;
          font-weight:800;
          color:#111827;
        }

        h1 span{
          display:block;
          background:linear-gradient(90deg,#f97316,#fb923c);
          -webkit-background-clip:text;
          -webkit-text-fill-color:transparent;
        }

        p{
          max-width:700px;
          margin:30px auto;
          color:#6b7280;
          font-size:20px;
          line-height:1.8;
        }

        .buttons{
          display:flex;
          justify-content:center;
          gap:18px;
          flex-wrap:wrap;
          margin-top:45px;
        }

        button{
          border:none;
          border-radius:999px;
          padding:18px 34px;
          font-size:17px;
          cursor:pointer;
          transition:.3s;
        }

        .primary{
          background:linear-gradient(90deg,#f97316,#ea580c);
          color:white;
          box-shadow:0 18px 45px rgba(249,115,22,.35);
        }

        .primary:hover{
          transform:translateY(-4px);
        }

        .secondary{
          background:white;
          border:1px solid #fdba74;
          color:#ea580c;
        }

        @media(max-width:768px){

          h1{
            font-size:46px;
          }

          p{
            font-size:17px;
          }

          .leftGlow,
          .rightGlow{
            width:140vw;
            height:120vw;
            top:-70vw;
          }

          .centerGlow{
            width:100vw;
            height:60vw;
          }
        }

      `}</style>
    </section>
  );
}


